import React from 'react'
import { useDispatch } from 'react-redux'
import { get, isEmpty } from 'lodash'
import { Box } from '@mui/material'
import InteractiveTagsList from '../../tags/InteractiveTagsList'
import api from '../../../api'
import {
  CACHE_TAG_BILLING_PAYMENT_LIST,
  CACHE_TAG_INVOICE_LIST,
  CACHE_TAG_BILLING_AR_LIST,
  CACHE_TAG_BILLING_MANUAL_INVOICE_LIST,
  CACHE_TAG_WORK_ORDER_REVIEW_LIST,
} from '../../../api/cacheTagTypes'

const RenderCustomerTagsCell = params => {
  const dispatch = useDispatch()
  const { row } = params
  const accountId = get(row, 'accountId')
  const componentProps = get(params, 'componentProps', {})
  const customerName = get(row, 'customerName') || get(row, 'accountName')
  const tagsData = { ...row, ...(customerName && { name: customerName }) }
  const handleClick = e => e.stopPropagation()

  return (
    <Box display="inline-flex" flex="noWrap" onClick={handleClick}>
      <InteractiveTagsList
        accountId={accountId}
        data={!isEmpty(tagsData) ? tagsData : undefined}
        disableLocation
        disableService
        tagsFlexWrap="nowrap"
        limit={1}
        onSave={(data, closeCallback) => {
          dispatch(
            api.util.invalidateTags([
              CACHE_TAG_INVOICE_LIST,
              CACHE_TAG_BILLING_PAYMENT_LIST,
              CACHE_TAG_BILLING_AR_LIST,
              CACHE_TAG_BILLING_MANUAL_INVOICE_LIST,
              CACHE_TAG_WORK_ORDER_REVIEW_LIST,
            ])
          )
          closeCallback()
        }}
        {...componentProps}
      />
    </Box>
  )
}

export default RenderCustomerTagsCell
